import { Package, Flame, HardHat, Ship, Truck, Factory, Landmark } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { useSeo } from "@/lib/seo";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Motion";
import { QuoteBand } from "@/components/Section";

const ICONS = [Package, Flame, HardHat, Ship, Truck, Factory, Landmark];

export default function Sectors() {
  const { t } = useLang();
  const p = t.sectorsPage;
  useSeo("sectors");
  return (
    <>
      <PageHero eyebrow={p.eyebrow} title={p.title} intro={p.intro} img="/img/supply.jpg" testId="sectors-hero" />
      <section className="bg-[#F7F9FB] py-24 lg:py-32" data-testid="sectors-page">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
          <div className="grid gap-px border border-[#8EA3BC]/40 bg-[#8EA3BC]/40 sm:grid-cols-2 lg:grid-cols-4">
            {p.sectors.map((s, i) => {
              const Icon = ICONS[i];
              return (
                <Reveal key={s.t} delay={(i % 4) * 0.07} className={`group bg-white p-8 transition-colors duration-500 hover:bg-[#0F2138] ${i === 6 ? "sm:col-span-2 lg:col-span-1" : ""}`} data-testid={`sector-card-${i}`}>
                  <div className="flex items-start justify-between">
                    <Icon className="h-7 w-7 text-[#1E3A5F] transition-colors duration-500 group-hover:text-[#C59B27]" aria-hidden="true" />
                    <span className="font-serif text-sm text-[#4A5D75] transition-colors duration-500 group-hover:text-[#C9D4E1]" dir="ltr">{String(i + 1).padStart(2, "0")}</span>
                  </div>
                  <h2 className="mt-14 font-serif text-2xl leading-snug text-[#1E3A5F] transition-colors duration-500 group-hover:text-white">{s.t}</h2>
                  <p className="mt-3 leading-relaxed text-[#4A5D75] transition-colors duration-500 group-hover:text-[#C9D4E1]">{s.d}</p>
                </Reveal>
              );
            })}
            <div className="hidden bg-[#1E3A5F] lg:col-span-1 lg:block" aria-hidden="true">
              <img src="/img/handling.jpg" alt="" loading="lazy" className="h-full w-full object-cover opacity-70" />
            </div>
          </div>
        </div>
      </section>
      <QuoteBand testId="sectors-quote-band" />
    </>
  );
}
